export const tableOption = {
    border: true,
    stripe: true,
    menuAlign: 'center',
    editBtn: false,
    delBtn: false,
    align: 'center',
    addBtn: false,
    columnBtn: false,
    menu:false,
    indexFixed:true,
    column: [
    {
      label: '课时名称',
      prop: 'courseCoursewareName',
      overHidden: true,
      align: 'left',
    },
    {
      label: '课程名称',
      prop: 'courseName',
      overHidden: true,
      align: 'left',
    },
    {
      label: '章节名称',
      prop: 'chapterName',
      overHidden: true,
      align: 'left',
    },
    {
      label: '课件名称',
      prop: 'coursewareName',
      overHidden: true,
      align: 'left',
    },
    {
      label: '收藏人数',
      prop: 'favoriteCount',
    },
    {
      label: '在学人数',
      prop: 'learningCount',
    },
    {
      label: '已完成人数',
      prop: 'completedCount',
    }]
  }